import Home from './Home.data-manager-var-adv.vue'

export default {
    Home
  }